export enum PermissionType {
  BOOLEAN = 'BOOLEAN',
  SECURITY = 'SECURITY',
  LIMIT = 'LIMIT'
}

export interface SecurityAttribute {
  id: number;
  type: PermissionType;
}
